import { ACCESS_LIST_FIELDS } from '@up2rent/models/src/fieldNames';
import {
  ACCOUNT_LABEL_TABLE_NAME,
  ADDRESS_TABLE_NAME,
  ADVERTISEMENT_TABLE_NAME,
  AGENCY_RATE_OWNER_TABLE_NAME,
  AGENCY_RATE_STATEMENT_TABLE_NAME,
  AGENCY_RATE_TABLE_NAME,
  APPLICATION_INVOICE_TABLE_NAME,
  BANK_ACCOUNT_TABLE_NAME,
  BILLING_ITEM_TABLE_NAME,
  BUILDING_EVENT_TABLE_NAME,
  BUILDING_OWNER_TABLE_NAME,
  BUILDING_SITE_TABLE_NAME,
  BUILDING_TABLE_NAME,
  CHARGE_ENVELOPE_TABLE_NAME,
  CHARGE_SECTION_TABLE_NAME,
  CAUSE_TABLE_NAME,
  DOCUMENT_EXTRACTION_TABLE_NAME,
  ENTITY_ALIAS_TABLE_NAME,
  IMPORT_RUN_TABLE_NAME,
  LEARNING_EVENT_TABLE_NAME,
  CHARGE_STATEMENT_TABLE_NAME,
  CHARGE_TABLE_NAME,
  COMMUNICATION_SETTINGS_PROFILE_TABLE_NAME,
  COMMUNICATION_TABLE_NAME,
  CONTACT_TABLE_NAME,
  COUNTERPARTY_IDENTITY_TABLE_NAME,
  COUNTERPARTY_ROLE_TABLE_NAME,
  CASH_EXPECTATION_TABLE_NAME,
  CUSTOM_FIELD_TABLE_NAME,
  CUSTOM_SUBSCRIPTION_TABLE_NAME,
  DOCUMENT_CATEGORY_TABLE_NAME,
  ENTITY_RELATION_TABLE_NAME,
  FEE_ARREARS_TABLE_NAME,
  FILE_TABLE_NAME,
  FILTER_GROUP_TABLE_NAME,
  INTEGRATION_TABLE_NAME,
  INTERNAL_COMMENT_TABLE_NAME,
  INVOICE_SETTING_TABLE_NAME,
  INVOICE_TABLE_NAME,
  LEASE_ACTION_HISTORY_TABLE_NAME,
  LEASE_ADDITIONAL_CLAUSE_TABLE_NAME,
  LEASE_CONTACT_TABLE_NAME,
  LEASE_PRICE_HISTORY_TABLE_NAME,
  LEASE_TABLE_NAME,
  LEASE_VARIOUS_OPERATION_TABLE_NAME,
  MORTGAGE_TABLE_NAME,
  NOTIFICATION_TABLE_NAME,
  PAYMENT_BATCH_TABLE_NAME,
  PAYMENT_ORDER_TABLE_NAME,
  POSTING_TABLE_NAME,
  RECONCILIATION_DECISION_TABLE_NAME,
  RECONCILIATION_SETTING_TABLE_NAME,
  RECURRING_PAYMENT_TEMPLATE_TABLE_NAME,
  REPARTITION_KEY_TABLE_NAME,
  REPAYMENT_STATEMENT_TABLE_NAME,
  SCHEDULE_RULE_TABLE_NAME,
  SENDER_RULE_TABLE_NAME,
  SENDING_SOURCE_TABLE_NAME,
  SETTING_TABLE_NAME,
  SIGNATURE_DOCUMENT_TABLE_NAME,
  STATEMENT_SETTING_TABLE_NAME,
  STATEMENT_TABLE_NAME,
  TAG_TABLE_NAME,
  TECHNIC_LIBRARY_TABLE_NAME,
  TECHNIC_TABLE_NAME,
  TEMPLATE_TABLE_NAME,
  TICKET_TABLE_NAME,
  TRANSACTION_RULE_TABLE_NAME,
  TRANSACTION_TABLE_NAME,
  UNIT_EVENT_TABLE_NAME,
  UNIT_INVENTORY_TABLE_NAME,
  UNIT_LEASE_TABLE_NAME,
  UNIT_OWNER_TABLE_NAME,
  UNIT_TABLE_NAME,
  VALUATION_TABLE_NAME,
  VARIOUS_OPERATION_TABLE_NAME,
  VAT_RATE_TABLE_NAME,
} from '@up2rent/models/src/tableNames';
import isNaN from 'lodash/isNaN';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';

import { isNilOrEmpty } from './objectUtils';
import { LooseObject, Model } from './types';

export {
  ACCOUNT_LABEL_TABLE_NAME,
  ADDRESS_TABLE_NAME,
  ADVERTISEMENT_TABLE_NAME,
  AGENCY_RATE_OWNER_TABLE_NAME,
  AGENCY_RATE_STATEMENT_TABLE_NAME,
  AGENCY_RATE_TABLE_NAME,
  BANK_ACCOUNT_TABLE_NAME,
  BILLING_ITEM_TABLE_NAME,
  BUILDING_EVENT_TABLE_NAME,
  BUILDING_OWNER_TABLE_NAME,
  BUILDING_SITE_TABLE_NAME,
  BUILDING_TABLE_NAME,
  CHARGE_ENVELOPE_TABLE_NAME,
  CHARGE_SECTION_TABLE_NAME,
  CAUSE_TABLE_NAME,
  DOCUMENT_EXTRACTION_TABLE_NAME,
  ENTITY_ALIAS_TABLE_NAME,
  IMPORT_RUN_TABLE_NAME,
  LEARNING_EVENT_TABLE_NAME,
  CHARGE_STATEMENT_TABLE_NAME,
  CHARGE_TABLE_NAME,
  COMMUNICATION_SETTINGS_PROFILE_TABLE_NAME,
  COMMUNICATION_TABLE_NAME,
  CONTACT_TABLE_NAME,
  COUNTERPARTY_IDENTITY_TABLE_NAME,
  COUNTERPARTY_ROLE_TABLE_NAME,
  CASH_EXPECTATION_TABLE_NAME,
  CUSTOM_FIELD_TABLE_NAME,
  CUSTOM_SUBSCRIPTION_TABLE_NAME,
  DOCUMENT_CATEGORY_TABLE_NAME,
  ENTITY_RELATION_TABLE_NAME,
  FEE_ARREARS_TABLE_NAME,
  FILE_TABLE_NAME,
  FILTER_GROUP_TABLE_NAME,
  INTEGRATION_TABLE_NAME,
  INTERNAL_COMMENT_TABLE_NAME,
  INVOICE_SETTING_TABLE_NAME,
  INVOICE_TABLE_NAME,
  LEASE_ACTION_HISTORY_TABLE_NAME,
  LEASE_ADDITIONAL_CLAUSE_TABLE_NAME,
  LEASE_CONTACT_TABLE_NAME,
  LEASE_PRICE_HISTORY_TABLE_NAME,
  LEASE_TABLE_NAME,
  LEASE_VARIOUS_OPERATION_TABLE_NAME,
  MORTGAGE_TABLE_NAME,
  NOTIFICATION_TABLE_NAME,
  PAYMENT_BATCH_TABLE_NAME,
  PAYMENT_ORDER_TABLE_NAME,
  POSTING_TABLE_NAME,
  RECONCILIATION_DECISION_TABLE_NAME,
  RECONCILIATION_SETTING_TABLE_NAME,
  RECURRING_PAYMENT_TEMPLATE_TABLE_NAME,
  REPARTITION_KEY_TABLE_NAME,
  REPAYMENT_STATEMENT_TABLE_NAME,
  SCHEDULE_RULE_TABLE_NAME,
  SENDER_RULE_TABLE_NAME,
  SENDING_SOURCE_TABLE_NAME,
  SETTING_TABLE_NAME,
  SIGNATURE_DOCUMENT_TABLE_NAME,
  STATEMENT_SETTING_TABLE_NAME,
  STATEMENT_TABLE_NAME,
  TAG_TABLE_NAME,
  TECHNIC_LIBRARY_TABLE_NAME,
  TECHNIC_TABLE_NAME,
  TEMPLATE_TABLE_NAME,
  TICKET_TABLE_NAME,
  TRANSACTION_RULE_TABLE_NAME,
  TRANSACTION_TABLE_NAME,
  UNIT_EVENT_TABLE_NAME,
  UNIT_INVENTORY_TABLE_NAME,
  UNIT_LEASE_TABLE_NAME,
  UNIT_OWNER_TABLE_NAME,
  UNIT_TABLE_NAME,
  VALUATION_TABLE_NAME,
  VARIOUS_OPERATION_TABLE_NAME,
  VAT_RATE_TABLE_NAME,
};

export const BLOCKED_RECIPIENT_TABLE_NAME = 'BlockedRecipient';

export const ADMIN_APPLICATION_INVOICE_TABLE_NAME = APPLICATION_INVOICE_TABLE_NAME;

export const DYNAMO_TABLENAMES = [
  ACCOUNT_LABEL_TABLE_NAME,
  ADDRESS_TABLE_NAME,
  ADVERTISEMENT_TABLE_NAME,
  AGENCY_RATE_TABLE_NAME,
  AGENCY_RATE_OWNER_TABLE_NAME,
  AGENCY_RATE_STATEMENT_TABLE_NAME,
  BILLING_ITEM_TABLE_NAME,
  BANK_ACCOUNT_TABLE_NAME,
  BUILDING_TABLE_NAME,
  BUILDING_EVENT_TABLE_NAME,
  BUILDING_OWNER_TABLE_NAME,
  BUILDING_SITE_TABLE_NAME,
  CHARGE_TABLE_NAME,
  CHARGE_ENVELOPE_TABLE_NAME,
  CHARGE_SECTION_TABLE_NAME,
  CAUSE_TABLE_NAME,
  DOCUMENT_EXTRACTION_TABLE_NAME,
  ENTITY_ALIAS_TABLE_NAME,
  IMPORT_RUN_TABLE_NAME,
  LEARNING_EVENT_TABLE_NAME,
  CHARGE_STATEMENT_TABLE_NAME,
  COMMUNICATION_TABLE_NAME,
  COMMUNICATION_SETTINGS_PROFILE_TABLE_NAME,
  CONTACT_TABLE_NAME,
  COUNTERPARTY_IDENTITY_TABLE_NAME,
  COUNTERPARTY_ROLE_TABLE_NAME,
  CASH_EXPECTATION_TABLE_NAME,
  CUSTOM_FIELD_TABLE_NAME,
  CUSTOM_SUBSCRIPTION_TABLE_NAME,
  DOCUMENT_CATEGORY_TABLE_NAME,
  ENTITY_RELATION_TABLE_NAME,
  FEE_ARREARS_TABLE_NAME,
  FILE_TABLE_NAME,
  FILTER_GROUP_TABLE_NAME,
  INTEGRATION_TABLE_NAME,
  INTERNAL_COMMENT_TABLE_NAME,
  INVOICE_TABLE_NAME,
  INVOICE_SETTING_TABLE_NAME,
  LEASE_TABLE_NAME,
  LEASE_ADDITIONAL_CLAUSE_TABLE_NAME,
  LEASE_CONTACT_TABLE_NAME,
  LEASE_ACTION_HISTORY_TABLE_NAME,
  LEASE_VARIOUS_OPERATION_TABLE_NAME,
  LEASE_PRICE_HISTORY_TABLE_NAME,
  MORTGAGE_TABLE_NAME,
  NOTIFICATION_TABLE_NAME,
  PAYMENT_BATCH_TABLE_NAME,
  PAYMENT_ORDER_TABLE_NAME,
  POSTING_TABLE_NAME,
  RECONCILIATION_DECISION_TABLE_NAME,
  RECONCILIATION_SETTING_TABLE_NAME,
  RECURRING_PAYMENT_TEMPLATE_TABLE_NAME,
  REPARTITION_KEY_TABLE_NAME,
  REPAYMENT_STATEMENT_TABLE_NAME,
  SCHEDULE_RULE_TABLE_NAME,
  SENDER_RULE_TABLE_NAME,
  SENDING_SOURCE_TABLE_NAME,
  SETTING_TABLE_NAME,
  SIGNATURE_DOCUMENT_TABLE_NAME,
  STATEMENT_TABLE_NAME,
  STATEMENT_SETTING_TABLE_NAME,
  TAG_TABLE_NAME,
  TECHNIC_TABLE_NAME,
  TECHNIC_LIBRARY_TABLE_NAME,
  TEMPLATE_TABLE_NAME,
  TICKET_TABLE_NAME,
  TRANSACTION_TABLE_NAME,
  TRANSACTION_RULE_TABLE_NAME,
  UNIT_TABLE_NAME,
  UNIT_EVENT_TABLE_NAME,
  UNIT_INVENTORY_TABLE_NAME,
  UNIT_LEASE_TABLE_NAME,
  UNIT_OWNER_TABLE_NAME,
  VALUATION_TABLE_NAME,
  VARIOUS_OPERATION_TABLE_NAME,
  VAT_RATE_TABLE_NAME,
] as const;

/**
 * Tables of `DYNAMO_TABLENAMES` without a `byClientId` index: a loop over every table of a workspace
 * cannot Query them by `clientId` and has to Scan them instead.
 */
export const DYNAMO_TABLENAMES_WITHOUT_CLIENT_ID_INDEX: readonly Model[] = [
  CAUSE_TABLE_NAME,
  DOCUMENT_EXTRACTION_TABLE_NAME,
  LEARNING_EVENT_TABLE_NAME,
];

export const resolveOneToMany = <Entity extends CommonEntity>(
  oneId: Entity[keyof CommonEntity],
  manyList: Entity[],
  foreignId: keyof Entity
) => {
  if ((foreignId as string).includes('Id')) {
    return manyList.filter((item) => item[foreignId] === oneId);
  } else {
    return manyList.filter((item) => {
      const foreignItem = item[foreignId] as unknown as CommonEntity;
      if (isNil(foreignItem)) console.error('Links broken', 'entity', item, 'linking variable', foreignId);
      return !isNil(foreignItem) && foreignItem.id === oneId;
    });
  }
};

export const resolveOneToOne = <Entity extends CommonEntity>(
  oneId: Entity[keyof CommonEntity],
  manyList: Entity[],
  foreignId: keyof Entity
) => {
  if ((foreignId as string).includes('Id') || foreignId === 'id') {
    return manyList.find((item) => item[foreignId] === oneId);
  }

  return manyList.find((item) => {
    const foreignItem = item[foreignId] as unknown as CommonEntity;
    if (isNil(foreignItem)) console.error('Links broken', 'entity', item, 'linking variable', foreignId);
    return !isNil(foreignItem) && foreignItem.id === oneId;
  });
};

interface CommonEntity {
  id: string;
}

export const resolveManyToMany = <OriginEntity extends CommonEntity, LinkingEntity extends CommonEntity>(
  originEntity: OriginEntity,
  originLinkingVariable: keyof LinkingEntity,
  linkingTable: LinkingEntity[]
): LinkingEntity[] => {
  return linkingTable.reduce((acc: LinkingEntity[], linkingElem) => {
    const originElem = linkingElem[originLinkingVariable] as unknown as OriginEntity;
    if (isNil(originElem))
      console.error('Links broken', 'entity', linkingElem, 'linking variable', originLinkingVariable);
    if (!isNil(originElem) && originElem.id === originEntity.id) {
      acc.push(linkingElem);
    }
    return acc;
  }, []);
};

// Legacy fields inherited from Amplify DataStore, still carried on every AppSync row and
// written by the backend, never by a user editing an entity. Their retirement is REN-7947.
// Extend this list per entity when a model has its own system-maintained fields.
export const NON_USER_EDITABLE_FIELDS = [
  '__typename',
  '_deleted',
  '_lastChangedAt',
  '_version',
  'createdAt',
  'updatedAt',
] as const;

export const cleanInputCreate = (input: LooseObject): LooseObject => {
  const cleanedInput: LooseObject = {};
  const bannedKeys: readonly string[] = NON_USER_EDITABLE_FIELDS;
  Object.keys(input).forEach((key) => {
    const value = input[key];
    // Don't keep models inside input
    if (isObject(value) && value.hasOwnProperty('__typename')) {
      return;
    }
    // Keep only the valid values, the others are ignored
    if (!bannedKeys.includes(key) && !isNaN(value) && !isNil(value) && value !== '') {
      cleanedInput[key] = value;
    }
  });
  return cleanedInput;
};

export const cleanInputUpdate = (
  input: LooseObject,
  removeVersion: boolean = true,
  recursive: boolean = false
): LooseObject => {
  // These keys are DataStore specific and should not be copied
  const bannedKeys: readonly string[] = removeVersion
    ? NON_USER_EDITABLE_FIELDS
    : NON_USER_EDITABLE_FIELDS.filter((field) => field !== '_version');

  return Object.keys(input).reduce((acc, key) => {
    if (bannedKeys.includes(key)) {
      return acc;
    }
    const value = input[key];

    if (isNil(value) || isNaN(value) || value === '') {
      if (ACCESS_LIST_FIELDS.includes(key)) {
        return acc;
      }
      acc[key] = null;
      return acc;
    }

    if (recursive && typeof value === 'object') {
      const rawNewValue = cleanInputUpdate(value as LooseObject, removeVersion, recursive);
      // recursion transforms all arrays into raw object, so we must turn them back into arrays
      acc[key] = Array.isArray(value) ? Object.values(rawNewValue) : rawNewValue;
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {} as LooseObject);
};
/* Check only basic type, object types should be handled separately */
export const shouldUpdate = (original: LooseObject, newObject: LooseObject, arrayOfFieldsToCheck?: string[]) => {
  if (!isNilOrEmpty(arrayOfFieldsToCheck)) {
    return arrayOfFieldsToCheck.some((field) => {
      return original[field] !== newObject[field];
    });
  }

  let needsUpdate = false;
  for (const key of Object.keys(newObject)) {
    if (original[key] !== newObject[key]) {
      // Ignore object types (but not the null type!)
      if (
        !(
          (typeof original[key] === 'object' && original[key] !== null) ||
          (typeof newObject[key] === 'object' && newObject[key] !== null)
        )
      )
        needsUpdate = true;
    }
  }
  return needsUpdate;
};

export const getReadId = (clientId: string, modelName: Model) => {
  const cleanId = clientId.includes('#') ? getClientId(clientId) : clientId;

  return `R#${fromModelNameToAuthorizationToken(modelName)}#${cleanId}`;
};

export const getTableClientId = (clientId: string, modelName: Model) => {
  const cleanId = clientId.includes('#') ? getClientId(clientId) : clientId;

  return `${fromModelNameToAuthorizationToken(modelName)}#${cleanId}`;
};

export const getClientId = (tableClientId: string) => {
  const clientId = tableClientId.includes('#') ? tableClientId.split('#')?.[1] : tableClientId;
  return isNilOrEmpty(clientId) ? '-1' : clientId;
};

export const fromModelNameToAuthorizationToken = (modelName: Model) => {
  switch (modelName) {
    case ADDRESS_TABLE_NAME:
    case BUILDING_TABLE_NAME:
    case BUILDING_OWNER_TABLE_NAME:
    case BUILDING_SITE_TABLE_NAME:
    case CONTACT_TABLE_NAME:
    case CUSTOM_FIELD_TABLE_NAME:
    case CUSTOM_SUBSCRIPTION_TABLE_NAME:
    case ENTITY_RELATION_TABLE_NAME:
    case FILTER_GROUP_TABLE_NAME:
    case INTERNAL_COMMENT_TABLE_NAME:
    case SCHEDULE_RULE_TABLE_NAME:
    case SENDER_RULE_TABLE_NAME:
    case TAG_TABLE_NAME:
    case UNIT_TABLE_NAME:
    case UNIT_INVENTORY_TABLE_NAME:
    case UNIT_OWNER_TABLE_NAME:
    case VAT_RATE_TABLE_NAME:
      return 'Basic';

    case ACCOUNT_LABEL_TABLE_NAME:
    case AGENCY_RATE_STATEMENT_TABLE_NAME:
    case CHARGE_TABLE_NAME:
    case CHARGE_ENVELOPE_TABLE_NAME:
    case CHARGE_SECTION_TABLE_NAME:
    case CAUSE_TABLE_NAME:
    case ENTITY_ALIAS_TABLE_NAME:
    case IMPORT_RUN_TABLE_NAME:
    case DOCUMENT_EXTRACTION_TABLE_NAME:
    case LEARNING_EVENT_TABLE_NAME:
    case CHARGE_STATEMENT_TABLE_NAME:
    case COUNTERPARTY_IDENTITY_TABLE_NAME:
    case COUNTERPARTY_ROLE_TABLE_NAME:
    case CASH_EXPECTATION_TABLE_NAME:
    case FEE_ARREARS_TABLE_NAME:
    case INVOICE_TABLE_NAME:
    case INVOICE_SETTING_TABLE_NAME:
    case LEASE_VARIOUS_OPERATION_TABLE_NAME:
    case PAYMENT_BATCH_TABLE_NAME:
    case PAYMENT_ORDER_TABLE_NAME:
    case POSTING_TABLE_NAME:
    case RECONCILIATION_DECISION_TABLE_NAME:
    case RECONCILIATION_SETTING_TABLE_NAME:
    case RECURRING_PAYMENT_TEMPLATE_TABLE_NAME:
    case REPARTITION_KEY_TABLE_NAME:
    case REPAYMENT_STATEMENT_TABLE_NAME:
    case STATEMENT_TABLE_NAME:
    case STATEMENT_SETTING_TABLE_NAME:
    case TRANSACTION_TABLE_NAME:
    case TRANSACTION_RULE_TABLE_NAME:
    case VARIOUS_OPERATION_TABLE_NAME:
      return TRANSACTION_TABLE_NAME;

    case LEASE_TABLE_NAME:
    case LEASE_ADDITIONAL_CLAUSE_TABLE_NAME:
    case LEASE_CONTACT_TABLE_NAME:
    case UNIT_LEASE_TABLE_NAME:
    case LEASE_PRICE_HISTORY_TABLE_NAME:
    case LEASE_ACTION_HISTORY_TABLE_NAME:
      return LEASE_TABLE_NAME;

    case BUILDING_EVENT_TABLE_NAME:
    case VALUATION_TABLE_NAME:
      return VALUATION_TABLE_NAME;

    case ADVERTISEMENT_TABLE_NAME:
      return ADVERTISEMENT_TABLE_NAME;

    case BANK_ACCOUNT_TABLE_NAME:
      return BANK_ACCOUNT_TABLE_NAME;

    case UNIT_EVENT_TABLE_NAME:
      return UNIT_EVENT_TABLE_NAME;

    case COMMUNICATION_TABLE_NAME:
      return COMMUNICATION_TABLE_NAME;

    case DOCUMENT_CATEGORY_TABLE_NAME:
    case FILE_TABLE_NAME:
    case SIGNATURE_DOCUMENT_TABLE_NAME:
      return FILE_TABLE_NAME;

    case MORTGAGE_TABLE_NAME:
      return MORTGAGE_TABLE_NAME;

    case NOTIFICATION_TABLE_NAME:
      return NOTIFICATION_TABLE_NAME;

    case COMMUNICATION_SETTINGS_PROFILE_TABLE_NAME:
    case INTEGRATION_TABLE_NAME:
    case SENDING_SOURCE_TABLE_NAME:
    case SETTING_TABLE_NAME:
      return SETTING_TABLE_NAME;

    case TECHNIC_TABLE_NAME:
    case TECHNIC_LIBRARY_TABLE_NAME:
      return TECHNIC_TABLE_NAME;

    case TEMPLATE_TABLE_NAME:
      return TEMPLATE_TABLE_NAME;

    case TICKET_TABLE_NAME:
      return TICKET_TABLE_NAME;

    case AGENCY_RATE_TABLE_NAME:
    case AGENCY_RATE_OWNER_TABLE_NAME:
    case BILLING_ITEM_TABLE_NAME:
      return AGENCY_RATE_TABLE_NAME;

    default:
      return modelName;
  }
};

type WithDeleted = {
  _deleted?: boolean;
};

type RecursiveClean<T> = T extends Array<infer U> ? RecursiveClean<U>[] : T extends object ? CleanedObject<T> : T;

type CleanedObject<T> = {
  [K in keyof T]: K extends 'items'
    ? T[K] extends Array<infer I>
      ? RecursiveClean<Exclude<I, WithDeleted & I>>[]
      : T[K]
    : RecursiveClean<T[K]>;
};

export function removeDeletedItemsInObject<T>(value: T): RecursiveClean<T> {
  if (isNil(value) || !isObject(value)) {
    return value as RecursiveClean<T>;
  }

  if (Array.isArray(value)) {
    return value.map(removeDeletedItemsInObject) as RecursiveClean<T>;
  }

  const obj = value as Record<string, unknown>;

  const result = Object.entries(obj).reduce(
    (acc, [key, prop]) => {
      if (key === 'items' && Array.isArray(prop)) {
        acc.items = prop.reduce(
          (arr, item) => {
            if (item && typeof item === 'object' && !(item as WithDeleted)._deleted) {
              arr.push(removeDeletedItemsInObject(item));
            }
            return arr;
          },
          [] as ReturnType<typeof removeDeletedItemsInObject>[]
        );
      } else {
        acc[key] = removeDeletedItemsInObject(prop);
      }
      return acc;
    },
    {} as Record<string, unknown>
  );

  return result as RecursiveClean<T>;
}
